export enum Departments {
  en = 'en',
  ru = 'ru',
  la = 'la',
  tr = 'tr',
  br = 'br',
}

export enum Platforms {
  telegram = 'telegram',
  instagram = 'instagram',
}
